export default __webpack_public_path__ + "static/2.5.1/media/notFound.1546c44d.svg";